import { useEffect, useState } from "react";

/**
 * Trails `value` by `delay` ms.
 *
 * The search box drives a query against the whole county table. Without this
 * every keystroke was a round trip, and the responses could land out of order.
 */
export function useDebounced<T>(value: T, delay = 250): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setSettled(value), delay);
    return () => window.clearTimeout(timer);
  }, [value, delay]);

  return settled;
}
